export default __webpack_public_path__ + "static/media/abortion.89c32bff.png";